import axios, { AxiosResponse } from 'axios';
import Axios from 'axios';

const api = Axios.create({
    baseURL: '',
    timeout: 100000, // 请求超时 10s
});

function setHeaders(req: any) {
    return req
}

function responseSuccess(response: AxiosResponse) {
    if (response.request.responseURL.includes('download/template') || response.request.responseURL.includes('write/excel')) {
        return { data: response.request.responseURL }
    } else {
        return response;
    }
}

function responseFail(error: any) {
    if (error.response && error.response.data) {
        const code = error.response.status;
        const msg = error.response.data.message;
        console.error(`[Axios Error]`, error.response, code, msg);
    } else {
        console.error(`[Axios Error]`, error);
    }
    return Promise.reject(error);
}
api.interceptors.request.use(setHeaders)
api.interceptors.response.use(responseSuccess, responseFail);
export default api;
export { setHeaders };
